import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ed-social-media',
  templateUrl: './ed-social-media.component.html',
  styleUrls: ['./ed-social-media.component.scss'],
})
export class EdSocialMediaComponent implements OnInit {
  modulesText = {
    text: 'Durante il corso verranno analizzate le dinamiche di comunicazione sul web, in particolare le differenze/analogie riscontrate in quella utilizzata nei principali canali social, nei blog e nei forum.',
  };

  constructor() {}

  ngOnInit(): void {}
}
